"use client";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone, faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import type { SiteSettings } from "@/types";

interface MobileBottomNavProps {
  settings: SiteSettings | null;
}

export function MobileBottomNav({ settings }: MobileBottomNavProps) {
  const cta = settings?.ctaButtons;
  const contactInfo = settings?.contactInfo;

  const whatsappNumber = cta?.whatsapp?.number || settings?.socialLinks?.whatsapp || "";
  const phoneNumber = cta?.phone?.number || contactInfo?.phone || "";
  const emailAddress = cta?.email?.address || contactInfo?.email || "";

  if (!whatsappNumber && !phoneNumber && !emailAddress) return null;

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 flex md:hidden border-t bg-background/95 backdrop-blur shadow-[0_-4px_20px_rgba(0,0,0,0.1)]">
      {whatsappNumber && (
        <a
          href={`https://wa.me/${whatsappNumber.replace(/\D/g, "")}?text=Hello%20MotoHome,%20I%20would%20like%20to%20inquire%20about%20your%20services.`}
          target="_blank"
          rel="noopener noreferrer"
          className="flex flex-1 items-center justify-center py-3 transition-transform active:scale-95"
          aria-label="Chat on WhatsApp"
        >
          <FontAwesomeIcon icon={faWhatsapp} className="h-7 w-7 text-green-500" />
        </a>
      )}
      {phoneNumber && (
        <a
          href={`tel:${phoneNumber}`}
          className="flex flex-1 items-center justify-center py-3 transition-transform active:scale-95"
          aria-label="Call us"
        >
          <FontAwesomeIcon icon={faPhone} className="h-7 w-7 text-blue-500" />
        </a>
      )}
      {emailAddress && (
        <a
          href={`mailto:${emailAddress}`}
          className="flex flex-1 items-center justify-center py-3 transition-transform active:scale-95"
          aria-label="Email us"
        >
          <FontAwesomeIcon icon={faEnvelope} className="h-7 w-7 text-orange-500" />
        </a>
      )}
    </nav>
  );
}
